<template>
  <NumeraiModal
    ref="modal"
    :dialog="dialog"
    :button="false"
    :width="1000"
    :hide-header="true"
    :no-padding="true"
    :show-footer="false"
    @close="onClose"
  >
    <template v-slot:activator>
      <slot></slot>
    </template>
    <div class="modal-container flexrow">
      <div class="success-image">
        <div class="image-text">WELCOME</div>
        <div class="image-text">TO</div>
        <div class="image-text">THE</div>
        <div class="image-text">META</div>
        <div class="image-text">MODEL</div>
      </div>
      <div class="content flex_col">
        <div class="heading mb-6">You built your first model</div>
        <p>
          Continue to the next tutorial to learn about risk and how to improve
          your performance.
        </p>
        <div class="flexrow align_center mt-12">
          <div class="ring-container mr-4">
            <ProgressRing
              :progress-percent="progressPercent"
              :numerator="tutorialNumerator"
              :denominator="tutorialDenominator"
            ></ProgressRing>
          </div>
          <div>
            <p class="mb-0"><strong>Tutorials complete</strong></p>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="flexrow justify_end mt-12">
          <button class="numerai-button" @click="closeAndRedirect">
            Next: Risk
          </button>
          <button class="numerai-button button-tertiary" @click="onClose">
            Close
          </button>
        </div>
      </div>
    </div>
  </NumeraiModal>
</template>

<script>
export default {
  components: {
    NumeraiModal: () => import('@/components/shared/NumeraiModal'),
    ProgressRing: () => import('@/components/shared/ProgressRing'),
  },
  props: {
    dialog: { type: Boolean, default: false },
    onClose: { type: Function, default: null },
    payoutDate: { type: String, default: 'September 19, 2023' },
  },
  data() {
    return {
      completionStatuses: null,
    }
  },
  computed: {
    progressPercent() {
      if (this.tutorialNumerator && this.tutorialDenominator) {
        return (
          (
            (this.tutorialNumerator / this.tutorialDenominator) *
            100
          ).toFixed() + '%'
        )
      }
      return '0%'
    },
    tutorialNumerator() {
      if (!this.completionStatuses) {
        return null
      }
      return Object.values(this.completionStatuses).filter(val => val).length
    },
    tutorialDenominator() {
      if (!this.completionStatuses) {
        return null
      }
      return Object.keys(this.completionStatuses).length
    },
  },
  watch: {
    async dialog(newVal) {
      if (newVal) {
        this.completionStatuses = await this.$client.getTutorialCompletion(
          'numerai',
        )
      }
    },
  },
  methods: {
    async closeAndRedirect() {
      try {
        await this.$client.dismissNotification(
          '60554464-1687-45d7-8141-c788deedf5b8',
        )
      } catch (err) {
        console.error(err)
      } finally {
        window.location.replace('/tutorial/feature-neutralization')
      }
    },
  },
}
</script>

<style scoped>
.success-image {
  min-width: 375px;
  height: 610px;
  background-size: cover;
  background-image: url('~@/assets/many_robots.png');
  padding: 55px 0 0 40px;
}

.image-text {
  color: #ffffff;
  font-size: 60px;
  font-weight: 800;
  font-family: var(--heading-font);
}

.nmr-text {
  font-weight: 700;
  color: var(--color-text-nmr);
}

.content {
  padding: 70px 50px;
}

.heading {
  font-size: 28px;
  font-weight: 700;
  text-transform: none;
}

.ring-container {
  width: 100px;
}

.modal-container {
  container-type: inline-size;
  container-name: success-modal;
}

@container success-modal (max-width: 796px) {
  .success-image {
    display: none;
  }
}
</style>
